import React from 'react';
//@ts-ignore
import * as logoStyle from '../../styles/logo.module.scss'
import { SVGProps } from "../../utils/typings";

const sharedColor = "#d60879";

export const Linkedin: React.FC<SVGProps> = ({ className }) => {
    return (
        <svg
            className={`${className ? className : ""} ${logoStyle.logo}`}
            height="512"
            viewBox="0 0 24 24"
            width="512"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M23.994 24v-.001H24v-8.802c0-4.306-.927-7.623-5.961-7.623-2.42 0-4.044 1.328-4.707 2.587h-.07V7.976H8.489v16.023h4.97v-7.934c0-2.089.396-4.109 2.983-4.109 2.549 0 2.587 2.384 2.587 4.243V24zM.396 7.977h4.976V24H.396zM2.882 0C1.291 0 0 1.291 0 2.882s1.291 2.909 2.882 2.909 2.882-1.318 2.882-2.909A2.884 2.884 0 002.882 0z" fill={sharedColor} />
        </svg>
    )
}

export const Github: React.FC<SVGProps> = ({ className }) => {
    return (
        <svg
            className={`${className ? className : ""} ${logoStyle.logo}`}
            height="512"
            viewBox="0 0 24 24"
            width="512"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M12 .5C5.37.5 0 5.78 0 12.292c0 5.211 3.438 9.63 8.205 11.188.6.111.82-.254.82-.567 0-.28-.01-1.022-.015-2.005-3.338.711-4.042-1.582-4.042-1.582-.546-1.361-1.335-1.725-1.335-1.725-1.087-.731.084-.716.084-.716 1.205.082 1.838 1.215 1.838 1.215 1.07 1.803 2.809 1.282 3.495.981.108-.763.417-1.282.76-1.577-2.665-.295-5.466-1.309-5.466-5.827 0-1.287.465-2.339 1.235-3.164-.135-.298-.54-1.497.105-3.121 0 0 1.005-.316 3.3 1.209.96-.262 1.98-.392 3-.398 1.02.006 2.04.136 3 .398 2.28-1.525 3.285-1.209 3.285-1.209.645 1.624.24 2.823.12 3.121.765.825 1.23 1.877 1.23 3.164 0 4.53-2.805 5.527-5.475 5.817.42.354.81 1.077.81 2.182 0 1.578-.015 2.846-.015 3.229 0 .309.21.678.825.56C20.565 21.917 24 17.495 24 12.292 24 5.78 18.627.5 12 .5z" fill={sharedColor} />
        </svg>
    )
}

export const Codepen: React.FC<SVGProps> = ({ className }) => {
    return (
        <svg
            className={`${className ? className : ""} ${logoStyle.logo}`}
            height="512"
            viewBox="0 0 24 24"
            width="512"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M24 7.598c-.044-.264-.08-.47-.36-.641C12.191.166 12.353-.34 11.61.109 2.933 5.503.518 6.706.171 7.126-.144 7.449 0 7.944 0 15.424c-.021.851 7.743 5.462 11.519 8.404.333.237.752.199 1.003-.029C23.746 15.843 24.019 16.163 24 15.424c0 0-.012-7.927 0-7.826zm-1.5 6.491l-3.876-2.359L22.5 9.033zm-5.277-3.212L12.75 8.155v-6.07l9.126 5.555zM12 14.51l-3.876-2.697L12 9.454l3.876 2.359zm-.75-12.426v6.074a537.339 537.339 0 01-4.451 2.734L2.124 7.64zm-5.857 9.658c-1.874 1.127-3.098 1.843-3.893 2.32V9.033zm1.33.924l4.527 3.149v5.999l-9.126-6.349zm6.027 9.149v-5.999l4.527-3.149 4.599 2.799z" fill={sharedColor} />
        </svg>
    )
}